import React, { useCallback, useState } from "react";
import toast from "react-hot-toast";
import Backend from "../../../../../Backend/Backend";

export default function Withdraw({ onClose }) {
  const [backend, setBackend] = useState(null);
  const [loading, setLoading] = useState(false);

  const [method, setMethod] = useState("upi");
  const [amount, setAmount] = useState("");

  // UPI
  const [upiId, setUpiId] = useState("");

  // Bank
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [ifscCode, setIfscCode] = useState("");

  // Init backend once
  React.useEffect(() => {
    const initBackend = async () => {
      const b = await new Backend().init();
      setBackend(b);
    };
    initBackend();
  }, []);

  const handleWithdrawal = useCallback(async () => {
    const amt = parseFloat(amount);
    if (!amt || amt < 500)
      return toast.error("Minimum withdrawal ₹500 required");

    setLoading(true);

    let data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      user_id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      amount: amount,
    };

    if (method === "upi") {
      if (!upiId) return toast.error("Enter UPI ID");
      data.upi = upiId;
    } else {
      if (!accountNumber || !ifscCode || !accountName)
        return toast.error("Enter all bank details");
      data.acc_name = accountName;
      data.acc_number = accountNumber;
      data.ifsc = ifscCode;
    }

    try {
      const r = await backend.withdrawal(data);
      if (r.error === "False") {
        toast.success(r.message);
        setAmount("");
        setUpiId("");
        setAccountName("");
        setAccountNumber("");
        setIfscCode("");
        onClose();
      } else {
        toast.error(r.message);
      }
    } catch (err) {
      toast.error("Network error");
    } finally {
      setLoading(false);
    }
  }, [amount, method, upiId, accountName, accountName, ifscCode]);

  if (!backend) return null;

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50">
      <div className="w-[600px] bg-[var(--background)] rounded-2xl p-6 border border-[var(--border)]">
        <div className="flex justify-between mb-6">
          <h3 className="text-lg font-semibold text-[var(--text)]">
            Withdraw Funds
          </h3>
          <button onClick={onClose}>✕</button>
        </div>

        {/* Amount */}
        <div className="mb-5">
          <label className="text-sm text-[var(--text)]">
            Withdrawal Amount
          </label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Minimum ₹500"
            className="w-full mt-2 p-2 rounded-lg bg-[var(--hover)] border border-[var(--border)] text-[var(--text)]"
          />
        </div>

        {/* Method Selector */}
        <div className="flex gap-4 mb-6">
          <button
            onClick={() => setMethod("upi")}
            className={`flex-1 py-2 rounded-xl ${
              method === "upi"
                ? "bg-[var(--primary)] text-white"
                : "bg-[var(--hover)] text-[var(--text)]"
            }`}
          >
            UPI
          </button>

          <button
            onClick={() => setMethod("bank")}
            className={`flex-1 py-2 rounded-xl ${
              method === "bank"
                ? "bg-[var(--primary)] text-white"
                : "bg-[var(--hover)] text-[var(--text)]"
            }`}
          >
            Bank
          </button>
        </div>

        {/* UPI Form */}
        {method === "upi" && (
          <input
            placeholder="Enter Your UPI ID"
            value={upiId}
            onChange={(e) => setUpiId(e.target.value)}
            className="w-full mb-4 p-2 rounded-lg bg-[var(--hover)] border border-[var(--border)] text-[var(--text)]"
          />
        )}

        {/* Bank Form */}
        {method === "bank" && (
          <div className="space-y-3">
            <input
              placeholder="Account Holder Name"
              value={accountName}
              onChange={(e) => setAccountName(e.target.value)}
              className="w-full p-2 rounded-lg bg-[var(--hover)] border border-[var(--border)] text-[var(--text)]"
            />
            <input
              placeholder="Account Number"
              value={accountNumber}
              onChange={(e) => setAccountNumber(e.target.value)}
              className="w-full p-2 rounded-lg bg-[var(--hover)] border border-[var(--border)] text-[var(--text)]"
            />
            <input
              placeholder="IFSC Code"
              value={ifscCode}
              onChange={(e) => setIfscCode(e.target.value)}
              className="w-full p-2 rounded-lg bg-[var(--hover)] border border-[var(--border)] text-[var(--text)]"
            />
          </div>
        )}

        <button
          onClick={handleWithdrawal}
          disabled={loading}
          className="w-full mt-6 py-3 rounded-xl bg-[var(--primary)] text-white font-semibold"
        >
          {loading ? "Processing..." : "Submit Withdrawal Request"}
        </button>
      </div>
    </div>
  );
}
